export default "__VITE_ASSET__e39fcf2c__"